import { BObject } from "./BObject";
import { Point, NumPair, NumberUtils } from '../Misc/Utils';
import { BMotionType } from "../Animations/BMotionEnums";
import { BMotion2 } from '../Animations/BMotion2';
import { Translate } from '../Animations/Translate';
import { Scale } from '../Animations/Scale';
import { Rotate } from '../Animations/Rotate';
import { Opacity } from '../Animations/Opacity';
import { MathFunc } from '../Graphics/MathFunc';
import { PointOps } from '../Graphics/PointOps';
import { Constants } from '../Misc/Constants';
import { BMotionLabel } from "../BMotionCharacterisitics/BMotionLabels";

export abstract class BMotionObject extends BObject{
    protected motions : Array<BMotion2>;

    protected curTransformMatrix: DOMMatrix = new DOMMatrix();
    protected curInverseTransformMatrix: DOMMatrix | null = null

    //private static bMotionCount : number = 0
    //private static bMotionPrefix : string = "Motion-"
    
    constructor(center : Point, twh : Point, frameRange : NumPair) {
        super(center, twh, frameRange);
        this.motions = new Array<BMotion2>();
        this.initializeMotions()
    }

    private initializeMotions(){
        this.motions[BMotionType.TRANS] = new Translate(this.centre);
        this.motions[BMotionType.SCALE] = new Scale();
        this.motions[BMotionType.ROTA] = new Rotate();
        this.motions[BMotionType.FADE] = new Opacity();
    }

    //override
    protected prepare() : void{
        super.prepare();

        for(let motion of this.motions){
            motion.prepare();
        }        
    }

    update(curFrame : number) : void{
        super.update(curFrame);
        for(let motion of this.motions){
            //if(this.isWithinFrameRange(curFrame, motion)){
                motion.update(curFrame);
            //}
        }
    }

    protected abstract justDrawObj(canvasCtx : CanvasRenderingContext2D): void;

    public drawObj(canvasCtx : CanvasRenderingContext2D, playing : boolean, curFrame : number) : void{
        this.preTransform(canvasCtx);
        this.transformCanvas2(canvasCtx);
        this.justDrawObj(canvasCtx);
        this.saveMatrix(canvasCtx);
        this.postTransform(canvasCtx);
    }

    preTransform(canvasCtx : CanvasRenderingContext2D): void{
        canvasCtx.save();
        /*canvasCtx.translate(this.centre[0], this.centre[1]);
        canvasCtx.rotate(MathFunc.angleToRadian(this.angle));
        canvasCtx.scale(this.scaleFactor[0], this.scaleFactor[1]);
        canvasCtx.globalAlpha = this.opacity;
        */
    }

    postTransform(canvasCtx : CanvasRenderingContext2D): void{
        canvasCtx.restore();
    }

    private saveMatrix(canvasCtx: CanvasRenderingContext2D): void{
        //store to find selected obj (to calc within bounds)
        this.curTransformMatrix = canvasCtx.getTransform();
        this.curInverseTransformMatrix = null;
    }

    transformCanvas2(canvasCtx : CanvasRenderingContext2D): void{
        var tPosition = [this.centre[0],this.centre[1]]
        var tAngle = this.angle
        var tScale = this.scaleFactor
        var tAlpha = this.opacity

        for(let motion of this.motions){
            switch(motion.TYPE){
                case BMotionType.TRANS:
                    var pt = motion.computedVal as Point;
                    tPosition = [pt[0],pt[1]];//PointOps.add(tPosition, motion.computedVal as Point);
                    break;
                case BMotionType.SCALE:
                    tScale = motion.computedVal as Point;
                    break;
                case BMotionType.ROTA:
                    tAngle = motion.computedVal[0];
                    break;
                case BMotionType.FADE:
                    tAlpha = NumberUtils.fitToRange( motion.computedVal[0], Constants.TRANSPARENT, Constants.OPAQUE);
                    break;
            }
        }

        canvasCtx.translate(tPosition[0], tPosition[1]);
        canvasCtx.rotate(MathFunc.angleToRadian(tAngle));
        canvasCtx.scale(tScale[0],tScale[1]);
        canvasCtx.globalAlpha = tAlpha;
    }

    /*transformCanvas(canvasCtx : CanvasRenderingContext2D): Array<Point>{
        var computedPos : Array<number> = this.centre;
        var computedAng : number = this.angle; //Todo: rotation of image
        var computedScaleFactor : Array<number> = this.scaleFactor;
        var alpha : number = Constants.OPAQUE;

        for(let motion of this.motions){
                switch(motion.TYPE){
                    case BMotionType.TRANS:
                        computedPos = motion.computedVal
                        canvasCtx.translate(computedPos[0], computedPos[1]);
                        break;
                    case BMotionType.SCALE:
                        computedScaleFactor = motion.computedVal
                        canvasCtx.scale(computedScaleFactor[0], computedScaleFactor[1]);
                    case BMotionType.LIBM:
                    case BMotionType.CUBM:
                        canvasCtx.translate(motion.getComputedPos()[0], motion.getComputedPos()[1]);
                        break;
                    case BMotionType.ROTA:
                    case BMotionType.SWING:
                        //computedAng = motion.getComputedAngle();
                        //computedPos = motion.getComputedPos();
                        //var rotationPos : Point = PointOps.add(computedPos, motion.getComputedPos());
                        //canvasCtx.translate(rotationPos[0], rotationPos[1]);
                        canvasCtx.translate(motion.getComputedPos()[0], motion.getComputedPos()[1]);
                        canvasCtx.rotate(motion.getComputedAngle());
                        //canvasCtx.translate(-rotationPos[0], -rotationPos[1]);
                        canvasCtx.translate(-motion.getComputedPos()[0], -motion.getComputedPos()[1]);
                        break;
                    case BMotionType.REVO:
                        canvasCtx.translate(motion.getComputedPos()[0], motion.getComputedPos()[1]);
                        break;
                    case BMotionType.CUPATH:
                    case BMotionType.LIPATH:
                        canvasCtx.translate(motion.getComputedPos()[0], motion.getComputedPos()[1]);
                        break;
                    case BMotionType.SCALE:
                        canvasCtx.translate(motion.getComputedPos()[0], motion.getComputedPos()[1]);
                        computedSize = motion.getComputedSize();
                        break;
                    case BMotionType.FADE:
                        alpha = motion.getComputedValue();
                        break;
                }
        }

        //For Rotation and Swing if any
        if(computedAng!=0){
            canvasCtx.translate(computedPos[0], computedPos[1]);
            canvasCtx.rotate(computedAng);
            canvasCtx.translate(-computedPos[0], -computedPos[1]);
        }
       
        canvasCtx.rotate(this.angle); 

        return [computedPos, computedScaleFactor, [computedAng, alpha]]
    }*/

    drawControlPoints(canvasCtx : CanvasRenderingContext2D, curFrame : number) : void{
        this.preTransform(canvasCtx);
        this.transformCanvas2(canvasCtx);
        super.drawControlPoints(canvasCtx, curFrame);
        this.postTransform(canvasCtx);
        
        /*canvasCtx.save();
        canvasCtx.translate(this.centre[0], this.centre[1]);
        
        //for(let motion of this.motions){
            //if(this.isWithinFrameRange(curFrame, motion)){
            //    motion.drawControl(canvasCtx);
            //}
        //}
        
        canvasCtx.restore();*/
    }

    isWithinBounds( point: Point ):boolean{
        var transformed = this.globalToLocal(point);
        return super.isWithinBounds(transformed);
    }

    /**
     * Method to check if the object is iselected
     * Todo: due to call to super, the point is transformed twice instead of once. 
     * @param curPoint 
     */
    checkSelection( curPoint : Point ) : boolean {
        var isControlSelected : boolean = false;
        var point = this.globalToLocal(curPoint);
        if(this.isObjectSelected()){
            /*for(let motion of this.motions){
                isControlSelected = motion.checkControlPointSelection(this.getPointRelativeToCentre(point));
                if(isControlSelected){
                    break;
                }
            }*/
            if(!isControlSelected){
                isControlSelected = super.checkTransformPointSelection(point) || this.checkControlPointSelection(point);
            }
        }
        this.isSelected = super.checkSelection(curPoint) || isControlSelected;
        return this.isSelected;
    }

    /**
     * Method to know if any of the control points other than transform point is selected.
     * For eg: in case of BVEctor, the vertices and bezier control points are checked
     * @param point globalToLocal converted cursor point
     */
    protected checkControlPointSelection(point: Point): boolean{
        return false;
    }

    protected globalToLocal(toTx: Point): Point{
        var tx = toTx;
        if(this.curInverseTransformMatrix == null){
            this.curInverseTransformMatrix = this.curTransformMatrix.inverse();
        }
        if(this.curInverseTransformMatrix.is2D){
            var domPt = this.curInverseTransformMatrix.transformPoint({x:toTx[0], y:toTx[1]});
            tx = [domPt.x, domPt.y];
            //console.log("global pt:"+toTx+" local pt:"+tx);
        } else {
            console.log("Inverse couldnt be calculated!");
        }
        return tx;
    }

    protected localToGlobal(toTx: Point): Point{
        var tx = toTx;
        if(this.curTransformMatrix){
            var domPt = this.curTransformMatrix.transformPoint({x:toTx[0], y:toTx[1]});
            tx = [domPt.x, domPt.y];
            //console.log("local pt:"+toTx+" global pt:"+tx);
        } else {
            console.log("Transform Matrix is null!!");
        }
        return tx;
    }

    //override
    isMotionObject() : boolean{
        return true;
    }

    hasMotions() : boolean { //woudl always be true based on current logic
        return this.motions.length > 0;
    }

    //override
    /*edit(lastMousePoint : Point, curMousePoint : Point) : void{
        //Need to add control points to motion.          
        /*for(let motion of this.motions){
            if(motion.getIsControlPointSelected()){
                motion.editControlPoint(this.getPointRelativeToCentre(curMousePoint));
                return;
            }
        }*
        //super is called if motion control points are not selected/edited in above loop
        //var lastTxPoint  = this.getTxPoint(lastMousePoint);
        //var curTxPoint = this.getTxPoint(curMousePoint);
        super.edit(lastMousePoint, curMousePoint);
    }*/

    resetAnimationPos() : void{
        for(let motion of this.motions){
            motion.reset();
        }
    }

    getMotions() : Array<BMotion2>{
        return this.motions;
    }

    getAnimatedMotions(): Array<BMotion2>{
        var animatedMotions = new Array<BMotion2>();
        for(let motion of this.motions){
            if(motion.canAnimate()){
                animatedMotions.push(motion);
            }
        }  
        return animatedMotions;
    }

    /*private addMotion(newBMotion : BMotion2){
        if(newBMotion != null){
            //newBMotion.setId(BMotionObject.bMotionPrefix+BMotionObject.bMotionCount);
            //BMotionObject.bMotionCount++;
            this.motions.push(newBMotion);
        }
    }*/

    /*addMotionWithDefaultValues(type : BMotionType){

        for(let motion of this.motions){
            if( motion.TYPE == type){
                console.log("motion already present: "+type);
                return;
            }
        }

        var newBMotion = null;
        switch(type){
            case BMotionType.TRANS:
                newBMotion = new Translate([this.centre[0],this.centre[1]]);
                break;
            case BMotionType.SCALE:
                newBMotion = new Scale();
                break;
            case BMotionType.ROTA:
                newBMotion = new Rotate();
                break;
            case BMotionType.FADE:
                newBMotion = new Opacity();
                break;*/
            /*case BMotionType.CUPATH:
                newBMotion = new CurvilinearPathBMotion(48, 5, this.curFrame);
                break;
            case BMotionType.ROTA:
                newBMotion = new RotationBMotion(24, 10, this.curFrame);
                break;
            case BMotionType.SCALE:
                newBMotion = new ScaleBMotion(this.getWH(), PointOps.multiply(this.getWH(), 2), Constants.ORIGIN, 24, 10, this.curFrame);
                break;
            
            case BMotionType.LIBM:
                newBMotion = new LinearBMotion([100,100], 24, 10, this.curFrame);
                break;
            case BMotionType.CUBM:
                newBMotion = new CurvilinearBMotion([350,250],24, 10, this.curFrame);
                break;
            case BMotionType.LIPATH:
                newBMotion = new LinearPathBMotion(48, 5, this.curFrame);
                break;
            case BMotionType.SWING:
                newBMotion = new SwingBMotion(100, 24, 10, this.curFrame);
                break;
            case BMotionType.REVO:
                newBMotion = new RevolutionBMotion([-175,0],175,75,48, 10, this.curFrame);
                break;
            case BMotionType.FADE:
                newBMotion = new FadeEffect(Constants.TRANSPARENT, Constants.OPAQUE, 24, 10, this.curFrame);
                break;*/
  /*      }
        if(newBMotion){
            this.addMotion(newBMotion);
            console.log("motion added of type "+type);
        }
    }*/

    getMotion(id : number) : BMotion2 | null{
        for(let i=0; i<this.motions.length; i++){
            if(id == this.motions[i].TYPE){
                return this.motions[i];
            }
        }
        return null;
    }

    setMotion(type: number, motion: BMotion2){
        this.motions[type] = motion;
    }

    //Assumes that only one motion of a particular type exists in an obj
    deleteMotion(id : number){
        for(let i=0; i<this.motions.length; i++){
            if(id == this.motions[i].TYPE){
                //this.motions.splice(i, 1);
                this.motions[i].clearAllKeyFrames(); //instead of deleting the motion we clear all the key frames.
                break;
            }
        }
    }

    updateMotion(id : number, label : BMotionLabel, value : any){
        var motion = this.getMotion(id);
        if(motion){
            motion.updatePropertyValue(label, value);
        }
    }

    //override
    /*addDelay(framesToDelay : number){
        super.addDelay(framesToDelay);
        if(this.motions.length > 0){
            for(let motion of this.motions){
                motion.addDelay(framesToDelay);
            }
        }
    }*/

    //Method to know if curframe is withing the motion's frame range
    /*protected isWithinFrameRange(curFrame : number, motion : BMotion) : boolean{
        //TEMP:
        //var frameRange : NumPair = motion.getFrameRange();
        //if(curFrame >= frameRange[0] && curFrame <= frameRange[1]){
            return true;
        //}
        //return false;
    }*/

    //override
    updateFrameRange(sceneTotalFrames: number): void{
        super.updateFrameRange(sceneTotalFrames);
        for(var motion of this.motions){
            //motion.updateFrameRangeBasedOnTotalSceneFrames(sceneTotalFrames);
        }
    }

    protected duplicate(dupObj : BMotionObject) : void{
        for(let i=0; i<this.motions.length; i++){
            //currently we dont clone motions. 
            //Todo: This needs tobe taken care in future
            dupObj.setMotion(this.motions[i].TYPE,this.motions[i].clone());
        }
        super.duplicate(dupObj);
    }

    /*addKeyFrame(){
        var transMotion = this.getMotion(BMotionType.TRANS);
        if(transMotion == null){
            this.addMotionWithDefaultValues(BMotionType.TRANS);
            transMotion = this.getMotion(BMotionType.TRANS);
        }
        (transMotion as Translate).addKeyFrame([this.centre[0], this.centre[1]], this.curFrame, true);
    }*/

    //Setters
    //override
    public setCentre(tCentre : Point) : void{
        super.setCentre(tCentre);
        this.motions[BMotionType.TRANS].updateKeyFrame(this.curFrame, tCentre);
    }

    //override
    public setAngle(angle : number) : void{
        super.setAngle(angle);
        this.motions[BMotionType.ROTA].updateKeyFrame(this.curFrame, [angle]);
    }

    //override
    public setOpacity(alpha: number): void{
        super.setOpacity(alpha);
        this.motions[BMotionType.FADE].updateKeyFrame(this.curFrame, [alpha]);
    }
}